// UserTypeRoute.js
import React, { useState, useEffect } from 'react';
import { Navigate } from 'react-router-dom';
import axios from 'axios';

let BASE_URL = process.env.REACT_APP_BASE_URL


const UserTypeRoute = ({ children, allowedTypes }) => {
  const [userType, setUserType] = useState(null);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    const fetchStationDetails = async () => {
      try {
        const response = await axios.get(`${BASE_URL}web/stationDetails`);
        setUserType(response.data.type);
      } catch (error) {
        console.error('Error fetching station details:', error);
      } finally {
        setLoading(false);
      }
    };

    fetchStationDetails();
  }, []);

  if (loading) {
    return <div className="flex items-center justify-center min-h-screen">
      <div className="animate-spin rounded-full h-12 w-12 border-b-2 border-blue-500"></div>
    </div>;
  }

  if (!allowedTypes.includes(userType)) {
    return <Navigate to={userType === 'Annotator' ? '/blood-pressure' : '/dashboard'} />;
  }

  return children;
};

export default UserTypeRoute;